const PlaidPort = {
  add: function (app, env, key) {
    app.ports.plaidPortOpenModal.subscribe(function (practiceName) {
      if (!window.Plaid) {
        return;
      }

      Plaid.create({
        apiVersion: "v2",
        env: env,
        clientName: practiceName,
        key: key,
        product: ["auth"],
        onSuccess: function (publicToken, metadata) {
          app.ports.plaidPortOnSuccess.send({
            public_token: publicToken,
            metadata: metadata,
          });
        },
      }).open();
    });
  },
};

module.exports = PlaidPort;
